var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTunnelPlugIconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-acbd3e8d-4352-4320-90fd-992dd34a4e8b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.22 795.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-51f5f73d-c37a-4c17-a504-c1457e368ada {\n        fill: url(#uuid-7aa1542b-38f5-4ec4-8658-c94f4fc4827b);\n      }\n\n      .uuid-51f5f73d-c37a-4c17-a504-c1457e368ada, .uuid-77227ce6-6177-44ce-a570-6d6d2f893c19 {\n        stroke-width: 0px;\n      }\n\n      .uuid-77227ce6-6177-44ce-a570-6d6d2f893c19 {\n        fill: #2e8f68;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "uuid-7aa1542b-38f5-4ec4-8658-c94f4fc4827b",
    cx: 247.75,
    cy: 314.53,
    fx: 233.78,
    fy: 314.53,
    r: 574.19,
    gradientTransform: "translate(-364.77 566.4) rotate(-90.39) scale(1 1.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61e0ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ccda0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f9e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b5349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-51f5f73d-c37a-4c17-a504-c1457e368ada",
    d: "M423.76,605.55c-40.4-30.08-30.04-72.76-29.58-89.1,1.5-52.41,42.16-76.35,43.65-135.47,2.45-96.33-26.42-50.93-51.5-190.35-15.87-88.2-.01-114.18-19-139.67C342.05,17.02,295.26,0,245.61,0s-96.44,17.02-121.72,50.96c-18.99,25.49-3.6,50.9-19.48,139.1-25.08,139.42-53.47,94.6-51.04,190.92,1.51,59.12,42.17,83.05,43.65,135.47.48,16.35,10.83,59.02-29.58,89.1C16.63,643.4.8,675.5,0,700.06v.06c.28,8.24,2.54,16.56,7.43,24.94,11.42,19.58,72.28,69.97,238.18,69.97,162.78.04,226.76-50.39,238.18-69.97,4.89-8.4,7.15-16.73,7.43-24.94v-.04c-.8-24.55-16.61-56.67-67.46-94.53ZM245.61,103.59c-43.08,0-78.01-16.22-78.01-36.23s34.93-36.23,78.01-36.23,78.01,16.22,78.01,36.23-34.93,36.23-78.01,36.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-77227ce6-6177-44ce-a570-6d6d2f893c19",
    d: "M491.22,700.06v.05c-.27,8.25-2.54,16.56-7.43,24.94-11.41,19.58-72.26,69.95-238.08,69.97h-.2c-165.81-.02-226.66-50.39-238.08-69.97-4.89-8.38-7.15-16.69-7.43-24.94v-.05c6.79-69.68,76.35-85.55,93.99-129.56.52-1.28-24.84,82.96,151.62,82.96s151.11-84.24,151.62-82.96c17.64,44.01,87.2,59.88,93.99,129.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunnelPlugIconColor);
export default __webpack_public_path__ + "static/media/TunnelPlugIcon(Color).0a1235d234eec2cf002883cd3f8113dc.svg";
export { ForwardRef as ReactComponent };